import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { AuthenticationResult, PublicClientApplication } from '@azure/msal-browser';
import _ from 'lodash';

import { store } from './state/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loginRedirectOnce, msalConfig } from './services/auth.service';
import { loadReCaptchaScript } from './utils/recaptcha';

void loadReCaptchaScript().catch(() => undefined);

const INTERACTIVE_LOGIN_COMPLETED_KEY = 'INTERACTIVE_LOGIN_COMPLETED';
const LOGIN_IN_FLIGHT_KEY = 'LOGIN_IN_FLIGHT';

export const msalInstance = new PublicClientApplication(msalConfig);
const ensureActiveAccountOrLogin = async () => {
	const activeAccount = msalInstance.getActiveAccount();
	const accounts = msalInstance.getAllAccounts();
	if (!activeAccount && accounts.length === 1) {
		msalInstance.setActiveAccount(accounts[0]);
		return;
	}
	if (!activeAccount && accounts.length === 0) {
		await loginRedirectOnce(msalInstance);
	}
};

const handleRedirectResponse = (resp: AuthenticationResult | null) => {
	if (_.isNil(resp)) {
		const currentAccounts = msalInstance.getAllAccounts();
		currentAccounts.length === 1 && msalInstance.setActiveAccount(currentAccounts[0]);
		if (typeof window !== 'undefined') {
			sessionStorage.removeItem(INTERACTIVE_LOGIN_COMPLETED_KEY);
		}
	} else {
		msalInstance.setActiveAccount(resp.account);
		if (typeof window !== 'undefined') {
			sessionStorage.setItem(INTERACTIVE_LOGIN_COMPLETED_KEY, '1');
		}
	}
	if (typeof window !== 'undefined') {
		sessionStorage.removeItem(LOGIN_IN_FLIGHT_KEY);
	}
	ensureActiveAccountOrLogin();
};
msalInstance
	.handleRedirectPromise()
	.then(handleRedirectResponse)
	.catch((error) => {
		if (typeof window !== 'undefined') {
			sessionStorage.removeItem(INTERACTIVE_LOGIN_COMPLETED_KEY);
			sessionStorage.removeItem(LOGIN_IN_FLIGHT_KEY);
		}
		window.location.replace('/');
		// console.error(error.message);
	});

ensureActiveAccountOrLogin();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<MsalProvider instance={msalInstance}>
			<BrowserRouter>
				<Provider store={store}>
					<App />
				</Provider>
			</BrowserRouter>
		</MsalProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
